import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandFuelAddPage } from './cabsand-fuel-add';

@NgModule({
  declarations: [
    CabsandFuelAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandFuelAddPage),
  ],
})
export class CabsandFuelAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fuel-add/cabsand-fuel-add.module.ts